import * as React from 'react';
import PropTypes from 'prop-types';

const Logo = ({light}) => (
  <div className="flex items-center">
    <svg
      width="35px"
      height="32px"
      viewBox="0 0 35 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Artwork Systems Nordic A/S</title>
      <g
        id="AWSN-Home"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M23.6343896,0 C25.5033248,0 27.2302921,1.00610139 28.1647597,2.63931552 L34.2991493,13.3606845 C35.2336169,14.9938986 35.2336169,17.0061014 34.2991493,18.6393155 L28.1647597,29.3606845 C27.2302921,30.9938986 25.5033248,32 23.6343896,32 L11.3656104,32 C9.49667521,32 7.76970789,30.9938986 6.83524031,29.3606845 L0.700850689,18.6393155 C-0.233616896,17.0061014 -0.233616896,14.9938986 0.700850689,13.3606845 L6.83524031,2.63931552 C7.76970789,1.00610139 9.49667521,0 11.3656104,0 L23.6343896,0 Z M17.9168962,6.63826605 C17.2253991,6.42948431 16.4955789,6.82080239 16.2867972,7.51229945 L16.2867972,7.51229945 L16.2723729,7.56007366 C15.5764693,9.86494619 13.2096481,11.2326575 10.8651916,10.6847132 C10.4401313,10.5853685 9.99345085,10.7027523 9.67214782,10.9982349 C9.13594746,11.4913453 9.10101613,12.3257665 9.59412652,12.8619669 L9.59412652,12.8619669 L9.61312541,12.882626 C11.262409,14.6760307 11.262409,17.4340489 9.61312541,19.2274536 L9.61312541,19.2274536 L9.59412652,19.2481127 C9.29864395,19.5694157 9.18126015,20.0160962 9.28060485,20.4411564 C9.44639434,21.15051 10.155838,21.5911558 10.8651916,21.4253663 C13.2096481,20.877422 15.5764693,22.2451334 16.2723729,24.5500059 L16.2723729,24.5500059 L16.2867972,24.5977801 C16.4134019,25.0171022 16.7415085,25.3452088 17.1608306,25.4718135 C17.8523277,25.6805953 18.5821478,25.2892772 18.7909296,24.5977801 L18.7909296,24.5977801 L18.8053539,24.5500059 C19.5012575,22.2451334 21.8680787,20.877422 24.2125352,21.4253663 C24.6375954,21.524711 25.0842759,21.4073272 25.4055789,21.1118447 C25.9417793,20.6187343 25.9767106,19.784313 25.4836002,19.2481127 L25.4836002,19.2481127 L25.4646013,19.2274536 C23.8153177,17.4340489 23.8153177,14.6760307 25.4646013,12.882626 L25.4646013,12.882626 L25.4836002,12.8619669 C25.7790828,12.5406639 25.8964666,12.0939834 25.7971219,11.6689231 C25.6313324,10.9595695 24.9218888,10.5189238 24.2125352,10.6847132 C21.8680787,11.2326575 19.5012575,9.86494619 18.8053539,7.56007366 L18.8053539,7.56007366 L18.7909296,7.51229945 C18.6643248,7.09297734 18.3362183,6.76487078 17.9168962,6.63826605 Z"
          id="Combined-Shape"
          fill="#f5831e"
        />
      </g>
    </svg>

    <div className="font-sans ml-2 h-auto">
      <div
        className={
          light
            ? 'font-semibold text-sm -mb-0.5 text-gray-50'
            : 'font-semibold text-sm -mb-0.5'
        }
      >
        Kongsberg skæreborde
      </div>
      <div className={light ? 'text-xs text-gray-50' : 'text-xs'}>
        Artwork Systems Nordic A/S
      </div>
    </div>
  </div>
);

Logo.propTypes = {
  light: PropTypes.bool,
};

Logo.defaultProps = {
  light: false,
};

export default Logo;
